import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "fixed-bottom floating-navbar pt-0" }
const _hoisted_2 = { class: "navbar navbar-light" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "text-capitalize-first" }

import SvgIcon from "@/components/SvgIcon.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {

const items = ['home', 'tournaments', 'games', 'store', 'profile']

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
          return _createVNode(_component_router_link, {
            key: item,
            to: {name: item},
            class: "navbar-brand"
          }, {
            default: _withCtx(() => [
              _createVNode(SvgIcon, {
                icon: `menu/${item}`
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(item)), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        }), 64))
      ])
    ])
  ]))
}
}

})